import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/dashboard-view.vue"),
  },
  {
    path: "/carteira",
    name: "carteira",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/wallet-view.vue"),
  },
  {
    path: "/cobrancas",
    name: "cobrancas",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/charge-view.vue"),
  },
  {
    path: "/financeiro",
    name: "financeiro",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/financial-report-view.vue"
      ),
  },
  {
    path: "/financeiro/configuracao",
    name: "financeiro-configuracao",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/financial-config-view.vue"
      ),
  },
  {
    path: "/clientes/:cnpj",
    name: "clientes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/buy-license-view.vue"),
  },
  {
    path: "/clientes/:cnpj/pagamentos",
    name: "clientes-pagamentos",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/client-payment-view.vue"
      ),
  },
  {
    path: "/comprar",
    name: "comprar",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/buy-license-view.vue"),
  },
  {
    path: "/clientes",
    name: "clientes-lista",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/client-view.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
